// styles.js
import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 20px 40px;
  background-color: #f8f8f8;
`;

export const Form = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #ddd;
  width: 100%;
  max-width: 500px;
`;

export const Title = styled.h1`
  color: #cf0505;
  font-size: 24px;
  text-align: center;
  margin-bottom: 30px;
`;

export const InputGroup = styled.div`
  margin-bottom: 20px;
`;

export const InputGroupCheckbox = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #333;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #003366;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: #002244;
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 100px;
  left: 20px;
  background-color: transparent;
  border: none;
  font-size: 16px;
  color: #cf0505;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #800000;
  }
`;
